import React from 'react';
import Alert from 'react-bootstrap/Alert';
import Table from 'react-bootstrap/Table';

import BaseWidget from '../base-widget/BaseWidget';
import Loader from "../../loader/Loader";
import {SchemaStatistic} from "../../../types/SchemaStatistics";

type DatasetStatisticsWidgetProps = {
  schema?: string;
  loading?: boolean;
  error?: any;
  stats?: Array<SchemaStatistic>;
  isBound?: boolean;
}

class DatasetStatisticsWidget extends React.Component<DatasetStatisticsWidgetProps> {

  render() {
    return (
      <BaseWidget title="Dataset Statistics" className="DatasetStatisticsWidget">
        {
          this.props.loading && <Loader size='lg' block={true}/>
        }
        {
          !this.props.loading && this.props.stats && !this.props.error &&
          <SchemaStatistics stats={this.props.stats}/>
        }
        {
          !this.props.isBound && !this.props.error &&
          <Alert variant="info">Statistics can be loaded only for an active schema.</Alert>
        }
        {
          this.props.error && <Alert variant="danger">{this.props.error}</Alert>
        }
      </BaseWidget>
    );
  }
}

function SchemaStatistics(props: { stats: Array<SchemaStatistic> }) {
  return <Table size="sm" className="schema-statistics" borderless hover>
    <tbody>
    {
      props.stats.map((entry, index) => {
        return (<tr key={index}>
          <td>{entry.stat}</td>
          <td>{entry.value}</td>
        </tr>)
      })
    }
    </tbody>
  </Table>
}

export default DatasetStatisticsWidget;
